// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/aircraft-stability.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/aircraft-stability/aircraft-stability.js';
import g1 from '../lessons/aeronautics/aircraft-stability/maneuverability-and-controllability.js';

mount([g0, g1]);
